import './core/tokens.css';
import './core/base.css';

// Fixtures exist only in dev and test builds: this whole branch is gone from production (npm run verify:nofixtures checks it).
if (import.meta.env.VITE_FIXTURES) {
  const { installFixtures } = await import('./dev/fixtures.ts');
  await installFixtures();
}
await import('./boot.ts');
